module.exports = __webpack_public_path__ + "img/timeIcon.76a43800.svg";